import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Group, Unit, User } from "./users.interface";
import { InstallationResponse } from "../signatures/signatures.interface";

@Injectable({ providedIn: "root" })
export class UserService {
  constructor(private http: HttpClient) {}

  current = () => this.http.get<User>("/current-user");
  updateAll = (body: Record<string, unknown>) =>
    this.http.post<InstallationResponse>("/footer", body);
  units = () => this.http.get<Unit[]>("/footer/unit");
  groups = () => this.http.get<Group[]>("/footer/group");

  toggleDefaultInstallationForGroup = (
    groupKey: string,
    templateId: string,
    defaultInstallationEnabled: boolean,
  ) => {
    return this.http.put(`/organisation-groups/${groupKey}/default-signature`, {
      groupKey,
      templateId,
      defaultInstallationEnabled,
    });
  };
}
